/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

 import React, {useState, useEffect} from 'react';
 import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
 import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
 
 export default function AllowC3(props)
 {
     const [allowC3, setAllowC3] = useState(false);
 
     /** Set callback to value that is being passed through props */
     useEffect(() => {
        setAllowC3(props.value);
     },[props.value]);

     useEffect(() => {
         if(!props.permission){
             setAllowC3(false);
         }
     },[allowC3]);
 
     /**Handle Changes of callback checkbox */
     const handleAllowC3 = () => {
         setAllowC3(!allowC3);
         props.onChange(!allowC3);
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={allowC3}
                         onChange={handleAllowC3}
                         name="allowC3"
                         color="primary"
                         />
                     }
                     label="Allow C3"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Give permission for C3. Only Tenants with the C3 license are allowed to check the box.">
                         <PaymentOutlinedIcon color="primary"/>
                     </Tooltip>
                 </Grid>
             </Grid>
         </div>
     );
 }
 
 